module.exports = __webpack_public_path__ + "static/media/KMH_5215.d579ab20.jpg";